import { ReactNode, ComponentType } from "react";

interface IconRowProps {
  icon: ComponentType<{ className?: string }>;
  children: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function IconRow({ icon: Icon, children, action, className = "" }: IconRowProps) {
  return (
    <div className={`flex items-center gap-2.5 py-3 ${className}`} data-testid="icon-row">
      <Icon className="w-4 h-4 text-gray-400 dark:text-gray-500 flex-shrink-0" />
      <div className="flex-1 min-w-0 text-sm text-gray-900 dark:text-gray-100">{children}</div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
